module.exports = __webpack_public_path__ + "img/Dantam Hair 10.302d3d59.jpg";